import React from "react";
import "../style/AmazonDisclosure.css";

const AmazonDisclosure = () => {
  return (
    <div className="amazon-disclosure-container">
      <div className="page-header">
        <h1 className="page-title">Amazon Associate Program Disclosure</h1>
      </div>
      
      <div className="disclosure-content">
        <div className="disclosure-text">
          <p>
            The Picky Kitty participates in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for websites to earn fees by linking to Amazon.com and affiliated sites. As an Amazon Associate, The Picky Kitty earns from qualifying purchases. This helps support the site and allows us to continue offering tools and content free of charge to cat owners.
          </p>
          
          <div className="disclosure-details">
            <h2>What This Means</h2>
            <ul>
              <li>When you click on Amazon product links on our site and make a purchase, we may earn a small commission at no additional cost to you.</li>
              <li>This commission helps us maintain and improve The Picky Kitty website and keep our tools free for all cat owners.</li>
              <li>We only recommend products that we believe would be genuinely helpful for cat owners.</li>
              <li>Your trust is important to us, and we maintain our commitment to providing unbiased, helpful information.</li>
            </ul>
          </div>
          
          <div className="disclosure-note">
            <p>
              <strong>Thank you for your support!</strong> Your purchases help keep The Picky Kitty running and help as many cat owners as we can.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmazonDisclosure; 